import React from 'react';
import './Icon.scss';
const rootClassName = 'icon-component';

export const HamburgerIcon = () => {
  return (
    <svg
      className={rootClassName}
      viewBox='0 0 24 18'
      fill='currentColor'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.5 1H23.5C23.7761 1 24 0.776142 24 0.5C24 0.223858 23.7761 0 23.5 0H0.5C0.223858 0 0 0.223858 0 0.5C0 0.776142 0.223858 1 0.5 1ZM0.5 10H23.5C23.7761 10 24 9.77614 24 9.5C24 9.22386 23.7761 9 23.5 9H0.5C0.223858 9 0 9.22386 0 9.5C0 9.77614 0.223858 10 0.5 10ZM23.5 18H0.5C0.223858 18 0 17.7761 0 17.5C0 17.2239 0.223858 17 0.5 17H23.5C23.7761 17 24 17.2239 24 17.5C24 17.7761 23.7761 18 23.5 18Z'
      />
    </svg>
  );
};
